if (window.location.origin === "https://shreevaishnavisweets.com") {
  (function (ns, fetch) {
    ns.fetch = function () {
      const response = fetch.apply(this, arguments);
      response.then(res => {
        if (res.url.includes(`${window.location.origin}/cart/add`)) {
          window.opusOpen();
        }
      });
      return response;
    };
  })(window, window.fetch);
}
